import React, { useEffect, useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import { toast } from 'react-toastify';
import TapIcon from '../../../services/TapIcon';
import Loader from '../../../components/ui/Loader/Loader';

function RootCauseAnalysis(props) {
   
    const access_token              = useSelector(state => state.auth.access_token);
    const rcaDataSaveAPI            = IAM_API_BASE_URL_2 + "/ticket/rca_add";
    const rcaDatadeatilAPI          = IAM_API_BASE_URL_2 + "/ticket/rca_get";

    const [tableData, setTableData]                 =    useState([
                                                                    { id: 1, point: '', reason: '', cause: '' },
                                                                 ]);
    const [rca_loading, setRca_loading]             =    useState(false);
    const [rcaDetailLoading, setRcaDetailLoading]   =    useState(false);
    const [finalConclusion, setFinalConclusion]     =    useState('');
    const [actionPlan, setActionPlan]               =    useState('');
    const [editMode, setEditMode]                   =    useState(false);

    useEffect(() => {
        if (props.ticketData && props.ticketData.activity_id) {
            fetchRCAData(props.ticketData.activity_id);
        }
    }, [props.ticketData]);

    const fetchRCAData = (activityId) => {
        setRcaDetailLoading(true)
        HttpAPICall.withAthorization('GET', `${rcaDatadeatilAPI}/${activityId}`, access_token, {}, {}, (resp) => {
            if (resp.data) {
                const { rca_data, final_conclusion, action_plan } = resp.data;
                setTableData(rca_data && rca_data.length ? rca_data : [{ id: 1, point: '', reason: '', cause: '' }]);
                setFinalConclusion(final_conclusion || "");
                setActionPlan(action_plan || "");
            }
            setRcaDetailLoading(false)
        });
    };
    const handleInputChange = (id, field, value) => {
        let newData = [...tableData];
        
        if (field === 'cause') {
            newData[id - 1][field] = value;
            
            if (id < newData.length) {
                newData[id].point = `Why ${value} happened?`;
            } 
            else if (newData.length < 5) {
                newData.push({
                    id: newData.length + 1,
                    point: `Why ${value} happened?`,
                    reason: '',
                    cause: '',
                });
            }
        } else {
            newData = newData.map(d => d.id === id ? { ...d, [field]: value } : d);
        }
        
        setTableData(newData);
    };

    const handleSave = (event) => {
        event.preventDefault();
        setRca_loading(true);

        const SaveData = {
            ticket_id: props.ticketData.activity_id,
            rca_data: tableData,
            final_conclusion: finalConclusion,
            action_plan: actionPlan
        };

        HttpAPICall.withAthorization('POST', rcaDataSaveAPI, access_token, {}, SaveData, (resp) => {
            toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
            setEditMode(false); 
        }).then(() => {
            setRca_loading(false);
        });
    };

    const toggleEditMode = () => {
        setEditMode(!editMode);
    };

    if (rcaDetailLoading) {
        return <Loader />;
    }

    return (
        <div className="container my-4">
            <div className="tab_content_wrapper mt-2 d-flex justify-content-between">
                <span className="content_heading">Root Cause Analysis</span>
                <button type="button" className="btn btn-primary" onClick={toggleEditMode}>
                    {editMode ? 'View' : 'Edit'}
                </button>
            </div>

            {editMode ? (
                <>
                    <table className="table table-hover table-bordered mt-3">
                        <thead className="thead-dark">
                            <tr>
                                <th className="text-center" style={{ width: '10%' }}>Sr No.</th>
                                <th style={{ width: '30%' }}>Point Of Discussion</th>
                                <th style={{ width: '30%' }}>Discussion</th>
                                <th style={{ width: '30%' }}>Cause</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((row) => (
                                <tr key={row.id}>
                                    <td className='text-center align-middle'>{row.id}</td>
                                    <td>
                                        <textarea
                                            type="text"
                                            align="top"
                                            className="form-control"
                                            value={row.point}
                                            disabled={row.id > 1}
                                            onChange={(e) => handleInputChange(row.id, 'point', e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <textarea
                                            type="text"
                                            className="form-control"
                                            value={row.reason}
                                            onChange={(e) => handleInputChange(row.id, 'reason', e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <textarea
                                            type="text"
                                            className="form-control"
                                            value={row.cause}
                                            onChange={(e) => handleInputChange(row.id, 'cause', e.target.value)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    
                    <div className="tab_content_wrapper mt-2">
                        <span className="content_heading">Final Conclusion</span>
                    </div>
                    <div className='mt-3'>
                        <CKEditor
                            editor={ClassicEditor}
                            data={finalConclusion}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                setFinalConclusion(data);
                            }}
                            config={{
                                toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
                            }}
                        />
                    </div>
                    
                    <div className="tab_content_wrapper mt-2">
                        <span className="content_heading">Action Plan</span>
                    </div>
                    <div className='mt-3'>
                        <CKEditor
                            editor={ClassicEditor}
                            data={actionPlan}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                setActionPlan(data);
                            }}
                            config={{
                                toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
                            }}
                        />
                    </div>
                    
                    <div className="text-end mb-5 mt-3">
                        <button disabled={rca_loading} onClick={handleSave} type="submit" className="btn btn-primary">
                            Save {rca_loading && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}
                        </button>
                    </div>
                </>
            ) : (
                <>
                    <table className="table table-hover table-bordered mt-3">
                        <thead className="thead-dark">
                            <tr>
                                <th className="text-center" style={{ width: '10%' }}>Sr No.</th>
                                <th style={{ width: '30%' }}>Point Of Discussion</th>
                                <th style={{ width: '30%' }}>Discussion</th>
                                <th style={{ width: '30%' }}>Cause</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.length > 0 && tableData.some(row => row.point || row.reason || row.cause) ? (
                                tableData.map((row) => (
                                    <tr key={row.id}>
                                        <td className='text-center align-middle'>{row.id}</td>
                                        <td>{row.point || '-'}</td>
                                        <td>{row.reason || '-'}</td>
                                        <td>{row.cause || '-'}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center ">
                                        No records found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    <div className="tab_content_wrapper mt-2">
                        <span className="content_heading">Final Conclusion</span>
                    </div>
                    {finalConclusion ? (
                        <p className="mb-0 border p-3 w-100 mt-3" dangerouslySetInnerHTML={{ __html: finalConclusion }} />
                    ) : (
                        <p className="mb-0 border p-3 w-100 mt-3 text-muted">No conclusion added yet</p>
                    )}

                    <div className="tab_content_wrapper mt-3">
                        <span className="content_heading">Action Plan</span>
                    </div>
                    {actionPlan ? (
                        <p className="mb-0 border p-3 w-100 mt-3" dangerouslySetInnerHTML={{ __html: actionPlan }} />
                    ) : (
                        <p className="mb-0 border p-3 w-100 mt-3 text-muted">No action plan added yet</p>
                    )}
                </>
            )}
        </div>
    );
}

export default RootCauseAnalysis;